import { PERSONA_STAGE_RESULTS_CLASS } from "../../../../lib/persona-opportunity-stage-chrome.js";
import { PersonaOpportunityCard } from "../../../cards/PersonaOpportunityCard/PersonaOpportunityCard.js";
import { PersonaOpportunityEmptyPersonaState } from "../../../shared/PersonaOpportunityEmptyPersonaState/PersonaOpportunityEmptyPersonaState.js";
import { PersonaOpportunityPersonaGroupHeader } from "../../../shared/PersonaOpportunityPersonaGroupHeader/PersonaOpportunityPersonaGroupHeader.js";
import type { PersonaOpportunityPersonaGroup } from "../../../../lib/persona-opportunity-row-model.js";

export interface PersonaOpportunityCardsViewProps {
  groups: PersonaOpportunityPersonaGroup[];
  expandedIds: ReadonlySet<string>;
  onToggleGroup: (personaId: string) => void;
  isGenerating?: boolean;
  selectedIds?: ReadonlySet<string>;
  selectionEnabled?: boolean;
  onToggleSelect?: (opportunityId: string) => void;
}

export function PersonaOpportunityCardsView({
  groups,
  expandedIds,
  onToggleGroup,
  isGenerating = false,
  selectedIds,
  selectionEnabled = false,
  onToggleSelect,
}: PersonaOpportunityCardsViewProps) {
  return (
    <div
      data-task-scroller=""
      className={`space-y-0 px-4 pb-6 pt-4 ${PERSONA_STAGE_RESULTS_CLASS}`}
    >
      {groups.map((group, index) => {
        const expanded = expandedIds.has(group.personaId);
        return (
          <section
            key={group.personaId}
            className={
              index > 0
                ? "mt-11 border-t border-border pt-9"
                : undefined
            }
          >
            <PersonaOpportunityPersonaGroupHeader
              group={group}
              expanded={expanded}
              onToggle={() => onToggleGroup(group.personaId)}
            />
            {expanded ? (
              group.opportunities.length === 0 ? (
                <div className="mt-4">
                  <PersonaOpportunityEmptyPersonaState isGenerating={isGenerating} />
                </div>
              ) : (
                <div className="mt-4 grid gap-6 [grid-template-columns:repeat(auto-fill,minmax(min(720px,100%),1fr))]">
                  {group.opportunities.map((row) => (
                    <PersonaOpportunityCard
                      key={row.id}
                      row={row}
                      selected={selectedIds?.has(row.id) ?? false}
                      selectionEnabled={selectionEnabled}
                      onToggleSelect={onToggleSelect}
                    />
                  ))}
                </div>
              )
            ) : null}
          </section>
        );
      })}
    </div>
  );
}
